(function () {
  if (window.__clientsExperienceLoaded) return;
  window.__clientsExperienceLoaded = true;

  function slugify(value) {
    return (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function normalizeText(value) {
    return (value || "")
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function shuffle(array) {
    for (var i = array.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  function buildCategoryIndex(root) {
    var categoryNodes = root.querySelectorAll("[data-category-key]");
    var index = {};
    categoryNodes.forEach(function (node) {
      var rawKey = node.getAttribute("data-category-key") || "";
      var title = node.getAttribute("data-category-title") || "";
      var key = slugify(rawKey || title);
      if (!key) return;
      if (!index[key]) {
        index[key] = { key: key, title: title || rawKey };
      }
    });
    return index;
  }

  function setViewMode(root, mode) {
    root.setAttribute("data-view-mode", mode);
    var lists = root.querySelectorAll("[data-clients-list]");
    lists.forEach(function (list) {
      if (mode === "logos") {
        list.classList.add("clients-full__list--logos");
      } else {
        list.classList.remove("clients-full__list--logos");
      }
    });

    var buttons = root.querySelectorAll("[data-view-button]");
    buttons.forEach(function (button) {
      var active = button.getAttribute("data-view-button") === mode;
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function updateVisibility(root, state) {
    var groups = root.querySelectorAll("[data-group]");
    var items = root.querySelectorAll("[data-client-item]");
    var hasVisible = false;

    items.forEach(function (item) {
      var name = normalizeText(item.getAttribute("data-client-name") || "");
      var category = item.getAttribute("data-client-category") || "";
      var nameMatch = !state.search || name.indexOf(state.search) !== -1;
      var categoryMatch = state.category === "all" || category === state.category;
      var visible = nameMatch && categoryMatch;

      item.hidden = !visible;
      if (visible) hasVisible = true;
    });

    var subgroupEls = root.querySelectorAll("[data-subgroup]");
    subgroupEls.forEach(function (subgroupEl) {
      var subgroupItems = subgroupEl.querySelectorAll("[data-client-item]");
      var subgroupVisible = Array.prototype.some.call(subgroupItems, function (item) {
        return !item.hidden;
      });
      subgroupEl.hidden = !subgroupVisible;
    });

    groups.forEach(function (group) {
      var groupItems = group.querySelectorAll("[data-client-item]");
      var groupVisible = Array.prototype.some.call(groupItems, function (item) {
        return !item.hidden;
      });
      group.hidden = !groupVisible;
    });

    var emptyState = root.querySelector("[data-empty-state]");
    if (emptyState) {
      emptyState.hidden = hasVisible;
    }
  }

  function setAccordionVisibilityByCategory(root, category) {
    var groups = root.querySelectorAll("[data-group]");
    groups.forEach(function (group) {
      if (group.hidden) return;

      var accordionButton = group.querySelector("[data-accordion-button]");
      if (!accordionButton) return;

      var controls = accordionButton.getAttribute("aria-controls");
      var panel = controls ? document.getElementById(controls) : null;
      var groupCategory = group.getAttribute("data-category-key") || "";
      var shouldExpand = category === "all" || groupCategory === category;

      accordionButton.setAttribute("aria-expanded", shouldExpand ? "true" : "false");
      if (panel) panel.hidden = !shouldExpand;
    });
  }

  function toggleAccordion(button, expanded) {
    var controls = button.getAttribute("aria-controls");
    if (!controls) return;
    var panel = document.getElementById(controls);
    if (!panel) return;

    button.setAttribute("aria-expanded", expanded ? "true" : "false");
    panel.hidden = !expanded;
  }

  function bindAccordion(root) {
    var accordionButtons = root.querySelectorAll("[data-accordion-button]");
    if (!accordionButtons.length) return;

    root.setAttribute("data-js-enhanced", "true");
    accordionButtons.forEach(function (button, index) {
      var startsOpen = index === 0;
      toggleAccordion(button, startsOpen);

      button.addEventListener("click", function () {
        var isExpanded = button.getAttribute("aria-expanded") === "true";
        toggleAccordion(button, !isExpanded);
      });

      button.addEventListener("keydown", function (event) {
        if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
        event.preventDefault();
        var nextIndex = index + (event.key === "ArrowDown" ? 1 : -1);
        if (nextIndex < 0) nextIndex = accordionButtons.length - 1;
        if (nextIndex >= accordionButtons.length) nextIndex = 0;
        accordionButtons[nextIndex].focus();
      });
    });
  }

  function bindFilters(root) {
    var state = {
      search: "",
      category: "all",
    };

    var searchInput = root.querySelector("[data-clients-search]");
    var filterButtons = root.querySelectorAll("[data-filter-category]");
    var viewButtons = root.querySelectorAll("[data-view-button]");
    var mixedContainer = root.querySelector("[data-all-mixed]");
    var mixedList = root.querySelector("[data-all-mixed-list]");
    var groupedContainer = root.querySelector(".clients-full__groups");
    var isClientsExperience = root.getAttribute("data-clients-root") === "clients-experience";

    function rebuildMixedList() {
      if (!mixedContainer || !mixedList) return;
      mixedList.innerHTML = "";

      var sourceItems = root.querySelectorAll(".clients-full__groups [data-client-item]");
      var mixedItems = Array.prototype.slice.call(sourceItems).map(function (item) {
        var clone = item.cloneNode(true);
        clone.classList.add("client-item--chip");
        clone.hidden = false;
        return clone;
      });

      shuffle(mixedItems);
      mixedItems.forEach(function (item) {
        mixedList.appendChild(item);
      });
    }

    function toggleAllMixedView(isAllCategory) {
      if (!isClientsExperience || !mixedContainer || !groupedContainer) return;

      if (isAllCategory) {
        rebuildMixedList();
      }

      mixedContainer.hidden = !isAllCategory;
      groupedContainer.hidden = isAllCategory;
    }

    if (searchInput) {
      searchInput.addEventListener("input", function (event) {
        state.search = normalizeText(event.target.value);
        updateVisibility(root, state);
      });
    }

    filterButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        state.category = button.getAttribute("data-filter-category") || "all";
        filterButtons.forEach(function (candidate) {
          candidate.setAttribute("aria-pressed", candidate === button ? "true" : "false");
        });
        updateVisibility(root, state);
        setAccordionVisibilityByCategory(root, state.category);
        toggleAllMixedView(state.category === "all");
      });
    });

    viewButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setViewMode(root, button.getAttribute("data-view-button") || "text");
      });
    });

    setViewMode(root, root.getAttribute("data-default-view") || "text");
    updateVisibility(root, state);
    setAccordionVisibilityByCategory(root, state.category);
    toggleAllMixedView(state.category === "all");
  }

  function bindSimpleCategoryFilters(root, targetSelector) {
    if (!root || root.dataset.simpleFiltersBound === "true") return;

    var filterButtons = root.querySelectorAll("[data-filter-category]");
    var targets = root.querySelectorAll(targetSelector);
    if (!filterButtons.length || !targets.length) return;
    root.dataset.simpleFiltersBound = "true";
    var shouldRandomize = root.getAttribute("data-clients-root") === "trusted-by";
    var targetsArray = Array.prototype.slice.call(targets);

    function applyFilter(category) {
      targetsArray.forEach(function (target) {
        var targetCategory = target.getAttribute("data-category-key") || target.getAttribute("data-client-category") || "";
        var visible = category === "all" || targetCategory === category;
        target.hidden = !visible;
      });

      if (!shouldRandomize) return;

      var parent = targetsArray[0] && targetsArray[0].parentNode;
      if (!parent) return;

      var visibleTargets = [];
      var hiddenTargets = [];

      targetsArray.forEach(function (target) {
        if (target.hidden) {
          hiddenTargets.push(target);
        } else {
          visibleTargets.push(target);
        }
      });

      shuffle(visibleTargets);
      visibleTargets.concat(hiddenTargets).forEach(function (target) {
        parent.appendChild(target);
      });
    }

    function setPressedState(selected) {
      filterButtons.forEach(function (candidate) {
        var isActive = (candidate.getAttribute("data-filter-category") || "all") === selected;
        candidate.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    filterButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var selected = button.getAttribute("data-filter-category") || "all";
        setPressedState(selected);
        applyFilter(selected);
      });
    });

    var selectedButton =
      root.querySelector("[data-filter-category][aria-pressed='true']") ||
      root.querySelector("[data-filter-category='all']") ||
      filterButtons[0];
    var initialCategory = (selectedButton && selectedButton.getAttribute("data-filter-category")) || "all";
    setPressedState(initialCategory);
    applyFilter(initialCategory);
  }

  function initClientsRoots(scope) {
    var rootNode = scope || document;

    rootNode.querySelectorAll("[data-clients-root='trusted-by']").forEach(function (root) {
      bindSimpleCategoryFilters(root, "[data-client-item]");
    });

    rootNode.querySelectorAll("[data-clients-root='experience-groups']").forEach(function (root) {
      bindSimpleCategoryFilters(root, "[data-category-card]");
    });

    rootNode.querySelectorAll("[data-clients-root='clients-experience']").forEach(function (root) {
      if (root.dataset.clientsExperienceBound === "true") return;
      root.dataset.clientsExperienceBound = "true";
      root.dataset.categoryIndex = JSON.stringify(buildCategoryIndex(root));
      bindAccordion(root);
      bindFilters(root);
    });
  }

  initClientsRoots(document);

  document.addEventListener("shopify:section:load", function (event) {
    initClientsRoots(event.target);
  });
})();
